export default __webpack_public_path__ + "static/media/connect.2938613d.svg";